import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import { ToastrService } from 'ngx-toastr';
import {BsModalRef } from 'ngx-bootstrap/modal';
import {Subject} from 'rxjs';
import {ConfigQuestionService} from '../../../service/chat/configquestion-service';
import {ConfigQuestion} from '../../../models/chat/configquestion';
@Component({
  templateUrl: './configchat.component.html'

})
export class ConfigChatComponent implements OnInit, AfterViewInit {
  public language = language;
  public  dataConfigList: ConfigQuestion[] = [];
  public onClose: Subject<boolean>;
  constructor( public configQuestionService: ConfigQuestionService,
               public toastr: ToastrService,
               public _bsModalRef: BsModalRef

  ) {
  }
  ngAfterViewInit() {

  }
  ngOnInit(): void {
    this.onClose = new Subject();
    this.configQuestionService.findAllByActive(true).subscribe(data => this.dataConfigList = data);
  }

  public show() {
  }
  public onConfirm(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}

